<lib-forgot-password-reset
  [labels]="'lib.forgotPasswordReset' | translate"
  [bank]="theme"
  [email]="email"
  [token]="token"
  (close)="cancel()"
  (newPasswordSubmitted)="handleNewPasswordSubmission($event)"
></lib-forgot-password-reset>

@if (showSnackbar) {
  <div class="relative z-[100]">
    <lib-snackbar
      [labels]="'lib.snackbar' | translate"
      [theme]="snackbarTheme"
      [position]="'bottom'"
      [bank]="theme"
      [title]="snackbarText"
      [showIconLeft]="true"
      [showIconRight]="false"
    ></lib-snackbar>
  </div>
}
